export default __webpack_public_path__ + "static/9-90a1649ba14839496dd45e1b7242f6ce.png";